import {
  Dialog,
  DialogTitle,
  Typography,
  DialogContent,
  TextField,
  Box,
  IconButton,
  Grid,
} from "@mui/material";
import { Autocomplete } from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import options from "./options.config";

export default function DialogTutorial({ open, close }) {
  const [selectedOption, setSelectedOption] = React.useState({
    label: "CADASTRO DE PRODUTOS",
    url: `https://www.youtube.com/embed/E54kfunzysc`,
  });

  return (
    <Dialog maxWidth="sm" fullWidth open={open} onClose={() => close()}>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between">
          <Typography color="primary" align="center" variant="h6">
            Veja como faz
          </Typography>

          <IconButton size="medium" onClick={() => close()}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} justifyContent="center" direction="column">
          <Grid size="grow">
            <Autocomplete
              disableClearable
              options={options}
              getOptionLabel={(option) => option.label}
              fullWidth
              value={selectedOption}
              renderInput={(params) => (
                <TextField {...params} label="Assunto" variant="outlined" />
              )}
              onChange={(e, value) => setSelectedOption(value)}
            />
          </Grid>

          <Grid size="grow">
            <iframe
              title="Veja video"
              src={selectedOption.url}
              width="100%"
              height="400"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
